import React from 'react'
import Button from '@material-ui/core/Button';
import makeGlobalStyles from 'makeGlobalStyles';

export default function CallRecordingButton(props) {
  const classes = makeGlobalStyles();
  return (
    <Button
      classes={{ root: classes.helpButton }}
      onClick={() => {
        props.toggleRecording();
      }}
    >
      {props.text}
    </Button>
  );
}
